import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
} from "@chakra-ui/react";
import { FaFileCsv, FaFileExcel, FaRegFilePdf } from "react-icons/fa";

export const ExportButton = ({ handleExport, exportLoading }) => {
  return (
    <Menu placement="bottom-end">
      <MenuButton as={Button} colorScheme="gray" isDisabled={exportLoading}>
        {exportLoading ? (
          <Box paddingX={4}>
            <Spinner height={4} width={4} />
          </Box>
        ) : (
          "Export"
        )}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => handleExport("csv")} gap={2}>
          <FaRegFilePdf />
          Export as CSV
        </MenuItem>
        <MenuItem onClick={() => handleExport("excel")} gap={2}>
          <FaFileExcel />
          Export as Excel
        </MenuItem>
        <MenuItem onClick={() => handleExport("pdf")} gap={2}>
          <FaFileCsv />
          Export as PDF
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
